import { render, staticRenderFns } from "./auth_new.vue?vue&type=template&id=50f4aa20"
import script from "./auth_new.vue?vue&type=script&lang=js"
export * from "./auth_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports